/**
 * Token storage: dùng sessionStorage (mất khi đóng tab) — phù hợp app nội bộ.
 */
const KEY = 'gf.session_token';

export const tokenStorage = {
  get(): string | null {
    try {
      return sessionStorage.getItem(KEY);
    } catch {
      return null;
    }
  },
  set(token: string) {
    try {
      sessionStorage.setItem(KEY, token);
    } catch {
      // ignore (incognito / disabled)
    }
  },
  clear() {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      // ignore
    }
  },
};
